import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import { IAuthReduxProps } from '../../types/interfaces';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges';
import { useHistory } from 'react-router-dom';

const SplashContainerComponent = ({ 
  auth
 }: IAuthReduxProps) => {
  const history = useHistory();

  useEffect(() => {
    if(constants.ROLE_COMPTABLE === auth?.user?.speciality){
      if(auth?.user?.privileges?.includes(PRIVILEGE.LIST_ENCAISSEMENTS))
        history.push("/encaissements")
      else if(auth?.user?.privileges?.includes(PRIVILEGE.CONSULTATION))
        history.push("/consultation")
    }
    else{
      if(auth?.user?.privileges?.includes(PRIVILEGE.SUMMARY_PROJECT))
        history.push("/resume_projets")
      else if(auth?.user?.privileges?.includes(PRIVILEGE.VENTE_NORMALE))
        history.push("/vente")
      else if(auth?.user?.privileges?.includes(PRIVILEGE.CONSULTATION))
        history.push("/consultation")
    }
  }, [auth])

  return (
    <>{auth?.user?.id === 76 && <><h1 className="text-center">Site en maintenance, veuillez patientez</h1><h6 className="text-center">Service est en cours de maintenance, veuillez réessayer ultérieurement.</h6></>}</>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth
});

export default connect(mapStateToProps, {  })(SplashContainerComponent);
